import React from 'react'

import { cn } from '@/shared/lib/utils'

const LinearProgress = ({
	className,
	...props
}: React.ComponentProps<'div'>) => (
	<div
		data-slot='linear-progress'
		className={cn('w-full', className)}
		{...props}
	>
		<span
			className='relative z-0 block h-1 overflow-hidden bg-secondary'
			role='progressbar'
		>
			<span className='absolute top-0 bottom-0 left-0 w-auto animate-linear-progress-1 bg-primary' />
			<span className='absolute top-0 bottom-0 left-0 w-auto animate-linear-progress-2 bg-primary' />
		</span>
	</div>
)
LinearProgress.displayName = 'LinearProgress'
export { LinearProgress }
